<template>
    <div>
        <SecondaryNavbarComponent v-bind:nameAndRoute="nameAndRoute" v-bind:routeName="routeName"></SecondaryNavbarComponent>
        <router-view></router-view>
    </div>
</template>
<script>
  import SecondaryNavbarComponent from '@/components/secondary-navbar/SecondaryNavbarComponent.vue';

  export default {
    data () {
      return {
        routeName: 'list-buildings',
        nameAndRoute: [
          {
            'text': 'List Buildings',
            'routeName': 'list-buildings'
          },
        ]
      }
    },
    components: {
      SecondaryNavbarComponent
    }
  }
</script>